import { TableCell, TableRow, IconButton, Chip } from '@mui/material'
import React from 'react'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import editIcon from 'src/assets/icons/editIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'
import { notificationStatus } from 'src/utils/constants'
import { formatDate, formatTime12Hour } from 'src/utils/helpers'
import dayjs from 'dayjs'
type DataRowProps = {
  id: number
  createdDate: string
  status: string
  scheduledTime: string
  title: string
  selected: boolean
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  onEditClick: (id: number) => void
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  createdDate,
  status,
  scheduledTime,
  title,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
  onEditClick,
}: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell padding='checkbox'>
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>

      <TableCell>{dayjs(createdDate).format('DD MMM YYYY')}</TableCell>
      <TableCell>
        {status === notificationStatus.ACTIVE && <Chip color='success' label={`${status}`} />}
        {status === notificationStatus.INACTIVE && <Chip color='error' label={`${status}`} />}
      </TableCell>
      <TableCell>{formatTime12Hour(scheduledTime)}</TableCell>
      <TableCell>{title}</TableCell>
      <TableCell align='center'>
        <IconButton onClick={() => onEditClick(id)}>
          {' '}
          <img src={editIcon} alt='editIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
